import React from "react";
import { AccessibilityUtil, LocaleProvider, createDOMProps } from "react-native-web-internals";
import { jsx } from "react/jsx-runtime";
const createElement = (component, props, options) => {
  let accessibilityComponent;
  component && component.constructor === String && (accessibilityComponent = AccessibilityUtil.propsToAccessibilityComponent(props));
  const Component = accessibilityComponent || component,
    domProps = createDOMProps(Component, props, options),
    element = React.createElement(Component, domProps);
  return domProps.dir ? /* @__PURE__ */jsx(LocaleProvider, {
    direction: domProps.dir,
    locale: domProps.lang,
    children: element
  }) : element;
};
var createElement_default = createElement;
export { createElement_default as default };
//# sourceMappingURL=index.mjs.map
